<div id="app-bg" *ngIf="isFinishedLoading" class="main-app-container">
    <div class="app-top-content" *ngIf="isLoggedIn()">
        <nav-toggle-button (navWidthOutput)="toggleMenuButton($event)"></nav-toggle-button>
        <top-nav-bar [sideNavWidth]="sideNavWidth" class="app-top-nav-bar"></top-nav-bar>
    </div>
    <div class="app-bottom-content">
        <side-nav-bar
            [sideNavWidth]="sideNavWidth"
            *ngIf="isLoggedIn()"
            class="side-nav-bar-style"
        ></side-nav-bar>
        <div class="app-data-container">
            <app-toast></app-toast>
            <p-toast />
            <div class="print-canvas">
                <div class="main-content-section">
                    <router-outlet></router-outlet>
                    <router-outlet name="modal"></router-outlet>
                </div>
                <div style="text-align: right; margin-right: 20px" class="app-print-footer"></div>
            </div>
            <lg-footer class="app-footer"></lg-footer>
        </div>
    </div>
    <app-help-module *ngIf="isLoggedIn()"></app-help-module>
</div>
